import React, { useState } from 'react'
import { TariffUpgradeType } from '../../methods/TariffUpgradeType'
import { AdditionalServiceType } from '../../util/AdditionalServiceType'
import { PhoneVerificationInfoPopup } from '../../components/PhoneVerificationInfoPopup'
import { PassportVerificationInfoPopup } from '../../components/PassportVerificationInfoPopup'
import { SelfieVerificationInfoPopup } from '../../components/SelfieVerificationInfoPopup'
import { SigningSmsInfoPopup } from '../../components/SigningSmsInfoPopup'
import { SigningWhatsappInfoPopup } from '../../components/SigningWhatsappInfoPopup'
import { ContractLinkSmsInfoPopup } from '../../components/ContractLinkSmsInfoPopup'
import InfoButton from '../../components/InfoButton'
import ProSubscriptionSection from './ProSubscriptionSection'
import 'pages/Styles/AdditionalServices.sass'

type Props = {
    tariffsData: any
    onAddUpgradeToCart: (upgrade: any) => void
    onAddServiceToCart: (service: any) => void
    onAddProSubscriptionToCart: (tariff: any) => void
    cart: any[]
    $store?: any
}

function AdditionalServices({
    tariffsData,
    onAddUpgradeToCart,
    onAddServiceToCart,
    onAddProSubscriptionToCart,
    cart,
    $store,
}: Props) {
    const [showPhoneInfoPopup, setShowPhoneInfoPopup] = useState(false)
    const [showPassportInfoPopup, setShowPassportInfoPopup] = useState(false)
    const [showSelfieInfoPopup, setShowSelfieInfoPopup] = useState(false)
    const [showSigningSmsInfoPopup, setShowSigningSmsInfoPopup] = useState(false)
    const [showSigningWhatsappInfoPopup, setShowSigningWhatsappInfoPopup] = useState(false)
    const [showContractLinkSmsInfoPopup, setShowContractLinkSmsInfoPopup] = useState(false)

    function formatPrice(price: number): string {
        // Проверяем, является ли число целым (с учетом погрешности чисел с плавающей точкой)
        if (Math.abs(price % 1) < 0.0001) {
            return price.toFixed(0)
        }
        return price.toFixed(2)
    }

    // Получаем все дополнительные услуги из разных категорий (отображаются только активные тарифы с API)
    const allServices = [
        ...(tariffsData[AdditionalServiceType.AI_TEMPLATE_CONFIGURATION] || []),
        ...(tariffsData[AdditionalServiceType.TEMPLATE_CONFIGURATION] || []),
        ...(tariffsData[AdditionalServiceType.REALTY_CONFIGURATION] || []),
        ...(tariffsData[AdditionalServiceType.AMO_CONFIGURATION] || []),
        ...(tariffsData[AdditionalServiceType.BITRIX_CONFIGURATION] || []),
        ...(tariffsData[AdditionalServiceType.LEGAL_CHECKS] || []),
    ]

    console.log("allServices", allServices)
    const services = allServices.map(service => ({
        _id: service._id,
        name: service.name,
        description: service.description || getServiceDescription(service.type),
        icon: getServiceIcon(service.type),
        price: service.price,
        type: service.type,
        legal_checks_balance: service.legal_checks_balance,
        ai_template_configuration_balance: service.ai_template_configuration_balance
    }))

    function getServiceDescription(type: string): string {
        switch (type) {
            case AdditionalServiceType.TEMPLATE_CONFIGURATION:
                return 'Настройка шаблона договора специалистом'
            case AdditionalServiceType.REALTY_CONFIGURATION:
                return 'Настройка вебхука для интеграции с системами недвижимости'
            case AdditionalServiceType.AMO_CONFIGURATION:
                return 'Настройка вебхука для интеграции с AmoCRM'
            case AdditionalServiceType.BITRIX_CONFIGURATION:
                return 'Настройка вебхука для интеграции с Bitrix'
            case AdditionalServiceType.LEGAL_CHECKS:
                return 'Проверка документов на соответствие законодательству'
            case AdditionalServiceType.AI_TEMPLATE_CONFIGURATION:
                return 'Автоматическая настройка шаблона с помощью ИИ (разовая услуга на один шаблон)'
            default:
                return 'Дополнительная услуга'
        }
    }

    function getServiceIcon(type: string): string {
        switch (type) {
            case AdditionalServiceType.TEMPLATE_CONFIGURATION:
                return '👤'
            case AdditionalServiceType.REALTY_CONFIGURATION:
                return '🏠'
            case AdditionalServiceType.AMO_CONFIGURATION:
                return '📊'
            case AdditionalServiceType.BITRIX_CONFIGURATION:
                return '🔧'
            case AdditionalServiceType.LEGAL_CHECKS:
                return '⚖️'
            case AdditionalServiceType.AI_TEMPLATE_CONFIGURATION:
                return '🤖'
            default:
                return '🔧'
        }
    }

    function handleServiceClick(service: any) {
        const cartItem = {
            ...service,
            quantity: 1,
        }
        onAddServiceToCart(cartItem)
    }

    function handleUpgradeClick(upgrade: any) {
        const upgradePrice = getUpgradePrice(upgrade._id)
        const cartItem = {
            _id: upgrade._id,
            name: upgrade.name,
            type: 'upgrade',
            price: upgradePrice.price,
            quantity: 1,
            isUpgrade: true
        }
        onAddUpgradeToCart(cartItem)
    }

    function handleUpgradeInfoClick(event: React.MouseEvent, upgradeId: string) {
        event.stopPropagation()
        if (upgradeId === 'phone_verification') {
            setShowPhoneInfoPopup(true)
        } else if (upgradeId === 'passport_verification') {
            setShowPassportInfoPopup(true)
        } else if (upgradeId === 'selfie_verification') {
            setShowSelfieInfoPopup(true)
        } else if (upgradeId === 'signing_sms') {
            setShowSigningSmsInfoPopup(true)
        } else if (upgradeId === 'signing_whatsapp') {
            setShowSigningWhatsappInfoPopup(true)
        } else if (upgradeId === 'contract_link_sms') {
            setShowContractLinkSmsInfoPopup(true)
        }
    }

    function isInCart(_id: string, type: string) {
        if (type === 'upgrade') {
            // Для апгрейдов проверяем в тарифе
            const selectedPackage = cart.find(item => item.type === 'package_v2')
            return selectedPackage ? (selectedPackage.tariff_upgrades || []).includes(_id) : false
        } else {
            // Для остальных услуг проверяем как обычно
            return cart.some(item => item._id === _id && item.type === type)
        }
    }

    function currentTariff() { 
        const selectedPackage = cart.find(item => item.type === 'package_v2')
        return selectedPackage
    }

    function getAllUpgrades() {
        const selectedPackage = currentTariff()
        if (!selectedPackage || !selectedPackage.upgrade_additional_price) {
            return []
        }
        
        // Преобразуем upgrade_additional_price в массив апгрейдов
        return Object.entries(selectedPackage.upgrade_additional_price).map(([upgradeId, price]) => ({
            _id: upgradeId,
            name: TariffUpgradeType.getTitle(upgradeId),
            description: getUpgradeDescription(upgradeId),
            price: price as number
        }))
    }

    function getSignerVerificationUpgrades() {
        const allowedIds = new Set<string>(TariffUpgradeType.signerVerificationUpgrades)
        return getAllUpgrades().filter(upgrade => allowedIds.has(upgrade._id))
    }

    function getSigningCommunicationUpgrades() {
        const allowedIds = new Set<string>(
            TariffUpgradeType.signingCommunicationUpgradesForJurisdiction(
                $store?.userSession?.jurisdiction,
            ),
        )
        return getAllUpgrades().filter(upgrade => allowedIds.has(upgrade._id))
    }

    function getContractLinkUpgrades() {
        const allowedIds = new Set<string>(TariffUpgradeType.contractLinkUpgrades)
        return getAllUpgrades().filter(upgrade => allowedIds.has(upgrade._id))
    }

    function renderUpgradeCard(upgrade: any) {
        return (
            <div 
                key={upgrade._id} 
                className={`upgrade-card-v2 ${isInCart(upgrade._id, 'upgrade') ? 'selected' : ''}`}
                onClick={() => handleUpgradeClick(upgrade)}
            >
                <div className="upgrade-header">
                    <div className="upgrade-name">{upgrade.name}</div>
                    <div className="upgrade-icon">
                        {upgrade._id === 'signing_sms' || upgrade._id === 'contract_link_sms' ? '📱' : upgrade._id === 'signing_whatsapp' ? '💬' : '🔧'}
                    </div>
                </div>
                <div className="upgrade-description">
                    {upgrade.description}
                    <InfoButton 
                        onClick={(e) => handleUpgradeInfoClick(e, upgrade._id)} 
                        size="small" 
                    />
                </div>
                <div className="upgrade-price">{getUpgradePrice(upgrade._id).displayText}</div>
            </div>
        )
    }

    function getUpgradeDescription(upgradeId: string): string {
        switch (upgradeId) {
            case 'passport_verification':
                return 'Проверка паспортных данных на валидность'
            case 'phone_verification':
                return 'Проверка номера телефона по черному списку'
            case 'selfie_verification':
                return 'Сверка лица на селфи с фото в паспорте после подписания'
            case 'signing_sms':
                return 'Отправка кода подтверждения по SMS при подписании документов'
            case 'signing_whatsapp':
                return 'Отправка кода подтверждения в WhatsApp при подписании документов'
            case 'contract_link_sms':
                return 'SMS со ссылкой на документ при выставлении'
            default:
                return 'Дополнительная проверка'
        }
    }

    function getUpgradePrice(upgradeId: string): { price: number, displayText: string } {
        console.log("upgradeId", upgradeId)
        const selectedPackage = currentTariff()
        if (!selectedPackage || !selectedPackage.upgrade_additional_price || !selectedPackage.upgrade_additional_price[upgradeId]) {
            return {
                price: 0,
                displayText: 'Цена не указана'
            }
        }
        
        const packagePrice = selectedPackage.upgrade_additional_price[upgradeId] as number
        const price = packagePrice / selectedPackage.prepaid_documents_count
        const priceInRubles = price / 100 // Конвертируем из копеек в рубли

        return {
            price: priceInRubles,
            displayText: `${formatPrice(priceInRubles)} ₽ за документ`
        }
    }

    return (
        <>
            <div className="additionalServices">
                {getSignerVerificationUpgrades().length > 0 && (
                    <div className="upgradesSection">
                        <h2 className="H3_21_v2">Проверки подписантов</h2>
                            <div className="upgrades-grid-v2">
                                {getSignerVerificationUpgrades().map(renderUpgradeCard)}
                            </div>
                    </div>
                )}

                {getSigningCommunicationUpgrades().length > 0 && (
                    <div className="upgradesSection">
                        <h2 className="H3_21_v2">Код подтверждения при подписании</h2>
                            <div className="upgrades-grid-v2">
                                {getSigningCommunicationUpgrades().map(renderUpgradeCard)}
                            </div>
                    </div>
                )}

                {getContractLinkUpgrades().length > 0 && (
                    <div className="upgradesSection">
                        <h2 className="H3_21_v2">Ссылка клиенту</h2>
                            <div className="upgrades-grid-v2">
                                {getContractLinkUpgrades().map(renderUpgradeCard)}
                            </div>
                    </div>
                )}

                <ProSubscriptionSection
                    tariffs={tariffsData.pro_subscription || []}
                    cart={cart}
                    onAddToCart={onAddProSubscriptionToCart}
                />

                <div className="servicesSection">
                    <h2 className="H3_21_v2">Дополнительные услуги</h2>
                        <div className="services-grid-v2">
                            {services.map((service) => (
                                <div 
                                    key={service._id} 
                                    className={`service-card-v2 ${isInCart(service._id, service.type) ? 'selected' : ''}`}
                                    onClick={() => handleServiceClick(service)}
                                >
                                    <div className="service-header">
                                        <div className="service-icon">{service.icon}</div>
                                        <div className="service-name">{service.name}</div>
                                    </div>
                                    <div className="service-description">{service.description}</div>
                                    <div className="service-price">
                                        {service.legal_checks_balance 
                                            ? `${service.price / 100} ₽ за ${service.legal_checks_balance} проверок`
                                            : `${service.price / 100} ₽`
                                        }
                                    </div>
                                </div>
                            ))}
                        </div>
                </div>
            </div>

            {/* Попапы с информацией о проверках */}
            {showPhoneInfoPopup && (
                <PhoneVerificationInfoPopup onClose={() => setShowPhoneInfoPopup(false)} />
            )}
            
            {showPassportInfoPopup && (
                <PassportVerificationInfoPopup onClose={() => setShowPassportInfoPopup(false)} />
            )}

            {showSelfieInfoPopup && (
                <SelfieVerificationInfoPopup onClose={() => setShowSelfieInfoPopup(false)} />
            )}

            {showSigningSmsInfoPopup && (
                <SigningSmsInfoPopup onClose={() => setShowSigningSmsInfoPopup(false)} />
            )}

            {showSigningWhatsappInfoPopup && (
                <SigningWhatsappInfoPopup onClose={() => setShowSigningWhatsappInfoPopup(false)} />
            )}

            {showContractLinkSmsInfoPopup && (
                <ContractLinkSmsInfoPopup onClose={() => setShowContractLinkSmsInfoPopup(false)} />
            )}
        </>
    )
}

export default AdditionalServices